import { render, staticRenderFns } from "./Interest.vue?vue&type=template&id=44bffd78&"
import script from "./Interest.vue?vue&type=script&lang=js&"
export * from "./Interest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports